module.exports = __webpack_public_path__ + "d3b1dc3e5fb453cb5faa38d2bab56354.jpg";